import * as v from 'valibot';
import { hysaCalculatorFormSchema } from './formSchema';
import type { HYSACalculatorErrors, HYSACalculatorFormFields, ValidatedFormFields } from './types';

type ValidationResult =
  | {
      success: true;
      output: ValidatedFormFields;
    }
  | {
      errors: HYSACalculatorErrors;
      success: false;
    };

export function validate(formFields: HYSACalculatorFormFields): ValidationResult {
  const result = v.safeParse(hysaCalculatorFormSchema, formFields);
  if (result.success) {
    return {
      success: true,
      output: result.output,
    };
  }
  const errors = v.flatten(result.issues);
  return {
    success: false,
    errors: errors.nested as HYSACalculatorErrors,
  };
}
